import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=c216fa7a&scoped=true"
import script from "./Communication.vue?vue&type=script&lang=js"
export * from "./Communication.vue?vue&type=script&lang=js"
import style0 from "./Communication.vue?vue&type=style&index=0&id=c216fa7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c216fa7a",
  null
  
)

export default component.exports